import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {RoleType} from '@app/core/model/user';
import {Router} from '@angular/router';
import {environment} from '@env/environment';
import {OidcSecurityProxyService} from '@app/core/service/oidc.security.proxy.service';

@Component({
    selector: 'ngc-credentials-login',
    templateUrl: './credentials-login.component.html',
    styleUrls: ['./credentials-login.component.scss']
})
export class CredentialsLoginComponent implements OnInit {

    @Input() loginForm: UntypedFormGroup;
    @Input() loginFormErrors: any;
    @Input() loading$: BehaviorSubject<boolean>;
    @Input() supportUrl: string;

    @Output() formSubmit = new EventEmitter<void>();

    hasStsServer = (!!environment.stsServer);
    isDistrictLogin = true;

    constructor(private router: Router,
                private oidcSecurityProxyService: OidcSecurityProxyService
    ) {
    }

    ngOnInit(): void {
        this.isDistrictLogin = this.router.url.startsWith('/login/district');

        const currentLastAuthenticatedRole = localStorage.getItem('lastAuthenticatedRole');
        const lastAuthenticatedRole = (this.isDistrictLogin ? RoleType.INSTITUTIONAL_ADMIN : RoleType.APPLICATION_ADMIN);
        if (currentLastAuthenticatedRole !== lastAuthenticatedRole) {
            localStorage.setItem('lastAuthenticatedRole', lastAuthenticatedRole);
        }
    }

    onFormSubmit(loginFormValue: any): void {
        this.formSubmit.emit(loginFormValue);
    }

    loginAsVendorAdmin() {
        localStorage.setItem('lastAuthenticatedRole', RoleType.APPLICATION_ADMIN);
    }

    loginAsDistrictAdmin() {
        localStorage.setItem('lastAuthenticatedRole', RoleType.INSTITUTIONAL_ADMIN);
        if (environment.stsServer) {
            // this.oidcSecurityProxyService.authorize();
            window.location.href = environment.etxBaseURI;
        }
    }
}
